import axios from 'axios'

export default {
    fetchUsers ({ commit }) {
        return axios.get('/api/user').then((response) => {
            commit('populateUsers', response.data.data)
        })
    },

    fetchInvoices ({ commit }) {
        return axios.get('/api/invoices').then((response) => {
            commit('populateInvoices', response.data)
        })
    },

    updateUser ({ commit }, { userId, form }) {
        return form.put(`/api/user/${userId}`).then((response) => {
            commit('updateUser', response.data)
        })
    },

    removeUser ({ commit }, user) {
        return axios.delete(`/api/user/${user.id}`).then((response) => {
            commit('removeUser', response.data.data.id)
            commit('channel/REMOVE_MEMBER', response.data.data.id, { root: true })
        })
    },

    activateUser ({ commit }, user) {
        return axios.post(`/api/user/${user.id}/active`).then((response) => {
            commit('updateUser', response.data.data)
            commit('channel/SET_MEMBER', response.data.data, { root: true })
        })
    },

    deactivateUser ({ commit }, user) {
        return axios.delete(`/api/user/${user.id}/active`).then((response) => {
            commit('updateUser', response.data.data)
            commit('channel/SET_MEMBER', response.data.data, { root: true })
        })
    },

    inviteMembers ({ commit }, form) {
        return form.post('/api/invites').then((response) => {
            if (form.force === true) {
                commit('addUsers', response.data)
            }
        })
    },

    upgradeAccount ({ commit }, form) {
        return form.post('/api/subscriptions').then((response) => {
            commit('setTenant', response)
        })
    },

    setupPaymentIntent () {
        return axios.post('/api/payment-intents')
    },

    cancelSubscription ({ commit }) {
        return axios.delete('/api/subscriptions').then((response) => {
            commit('setCurrentSubscription', response.data)
        })
    },

    resumeSubscription ({ commit }) {
        return axios.post('/api/subscriptions/resume').then((response) => {
            commit('setCurrentSubscription', response.data)
        })
    },

    updatePaymentMethod ({ commit }, form) {
        return form.put('/api/payment-methods').then((response) => {
            commit('setTenant', response)
        })
    },

    applyCoupon ({ commit }, form) {
        return form.post('/api/coupons')
    }
}
